import React from "react";
import { Container, Row, Col, Image, Carousel, Card } from "react-bootstrap";
import "./CustomGradCakes.css"; // Create this CSS file for styling

export default function CustomGradCakes() {
  const imagePaths = [
    "/launch-party/cakeryPitch.png",
    "/launch-party/JUL07495.png",
  "/launch-party/JUL07507.png",
  "/launch-party/JUL07606.png",
  "/launch-party/JUL07614.png",
  "/launch-party/JUL08014.png",
  "/launch-party/JUL08029.png",
  "/launch-party/JUL08201.png",
  "/launch-party/JUL08204.png",
  "/launch-party/JUL08219.png",
  "/launch-party/JUL08250.png",
  "/launch-party/JUL08275.png",
  "/launch-party/JUL08292.png",
  ];

  return (
    <div className="gradcakes-page">
      <Container className="text-center py-5">
      <Image
            src="/CongratulationsGraduates.png"
            alt="Cakery Rice Grad Logo"
            className="grad-logo mb-1"
            // adjust width as needed
            />

        <h1 className="mb-3 heading-gradient">Custom Rice Graduation Cakes</h1>

        <p className="lead mb-4">
  Celebrate graduation with a <strong>custom</strong> Rice-themed cake!<br />
  Designed by you, made by a local bakery.
</p>


<Card className="text-center p-4 mb-5 story-card">
  <h5 className="mb-3">✨ How It Works</h5>
  <p style={{ marginBottom: 0 }}>
    Customize and order your cake through Cakery, and a Houston bakery will follow up to coordinate pickup or delivery.
  </p>
</Card>



   <div className="mt-4">
  <a href="/custom-grad-cake-creator" className="cta-gradcake-btn">
    🎂 Customize My Graduation Cake Today!
  </a>
 
</div>


<br></br>
<h4 className="mb-3"> Thank You, Class of 2025 <br />
     For Helping Shape the Start of Cakery</h4>

        <Carousel interval={4000} className="grad-cake-carousel mb-5">
          {imagePaths.map((src, idx) => (
            <Carousel.Item key={idx}>
              <div className="carousel-img-wrapper">
                <img src={src} alt={`Graduation Cake ${idx + 1}`} className="carousel-img" />
              </div>
            </Carousel.Item>
          ))}
        </Carousel>
      </Container>
    </div>
  );
}
